import { ITransaction } from '@/types'
import { formatAmount, formatDayMonthYear } from '@/utils/common'

// The aliases a support agent can give a transaction. The value is what the bank service stores;
// the label is what the panel shows in its place.
export const DESCRIPTION_ALIAS_OPTIONS = [
  { value: 'manualsalary', label: 'Manual Salary' },
  { value: 'manualexclude', label: 'Manual Exclude' },
] as const

export type DescriptionAlias = (typeof DESCRIPTION_ALIAS_OPTIONS)[number]['value']

// An alias set some other way is shown as stored rather than hidden.
export const aliasLabel = (value = '') =>
  DESCRIPTION_ALIAS_OPTIONS.find(option => option.value === value)?.label ?? value

// Selection is tracked by the id the update is addressed by. A row without one cannot be updated,
// so it is given no checkbox.
export const transactionKey = (transaction: ITransaction) => transaction.transactionId ?? ''

// What a row's checkbox is announced as, so a screen reader can tell the rows apart.
export const transactionLabel = (transaction: ITransaction) =>
  `transaction ${transaction.description || 'with no description'} on ${formatDayMonthYear(
    transaction.transactionDate
  )}, amount ${formatAmount(transaction.amount)}`
